import { Directive, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuditComponent, BaseComponent, ProgressBarService } from '@mrm/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Directive()
export class FormComponent extends BaseComponent {
  @Input() form: FormGroup;
  @Input() showHeader = true;
  @Input() isModal = false;

  constructor(protected __progressBarService: ProgressBarService,
    protected __toastr: ToastrService,
    protected __translateService: TranslateService,
    protected __router: Router,
    protected __modalService: NgbModal
  ) {
    super(__progressBarService, __toastr, __translateService, __router);
  }

  auditDetails(itemToAudit?: any): void {
    const modalRef = this.__modalService.open(AuditComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.textValue = itemToAudit ? itemToAudit : this.form.getRawValue();

    modalRef.result.then(null, (reason) => {
      // close was pressed.
    });
  }

  protected _addNameControls(disableAll: boolean = true) {
    this.form.addControl('firstName', new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(50)]));
    this.form.addControl('lastName', new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(50)]));
  }

}
